import NotificationsPage from "./NotificationsPage";
export default NotificationsPage;
